import * as React from 'react';
import MUIDataTable, { Responsive } from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from '../../../themes/theme';
import CustomPaginator from '../../common/CustomPaginator';
import exportIcon from '../../../assets/export';
import Menu from '@material-ui/core/Menu';
import InvoiceService from 'src/services/invoice';
import Button from '@material-ui/core/Button';
import LocaleFormating from 'src/translation/localeFormating';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import { downloadFile } from 'src/utils/downloadHelper';
import downarrowIcon from '../../../assets/downArrow';
import './Original.scss';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import { TableCell, TableRow } from '@material-ui/core';
import warningIcon from 'src/assets/warningIcon';
import Modal from 'src/components/common/Modal';
import CloseIcon from 'src/assets/close';
import * as _ from 'lodash';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';
function OriginalInvoice(props: any) {
  const [showWarning, setShowWarning] = React.useState(false);
  const [rowscount, setRowscount] = React.useState([1]);
  const [rowsSelected, setSelected] = React.useState([]);
  const [pagenumber, setPagenumber] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [displayState, setDisplayState] = React.useState([]);
  const [sortOrderState, setSortOrderState] = React.useState({});
  const exportOptions = [
    { label: `${i18n.t('invoices.exportasXLSX')}`, value: 'xlsx' },
    { label: `${i18n.t('invoices.exportasPDF')}`, value: 'pdf' },
    { label: `${i18n.t('invoices.exportasCSV')}`, value: 'csv' }
  ];
  const clickclose = () => {
    setShowWarning(false);
  };
  const showWarningMessage = () => {
    setShowWarning(true);
  };
  const checkDisplayState = (
    fileldName: string,
    state: boolean,
    isUpdate: boolean
  ) => {
    const stateList = displayState;
    let stateVal = state;
    if (isUpdate) {
      stateList[fileldName] = state ? 'add' : 'remove';
    } else {
      if (stateList[fileldName]) {
        stateVal = stateList[fileldName] === 'add' ? true : false;
      } else {
        stateList[fileldName] = state ? 'add' : 'remove';
      }
    }
    if (!_.isEqual(displayState, stateList)) {
      setDisplayState(stateList);
    }
    return stateVal;
  };
  const handlePagination = (newpage: number) => {
    const { datesFilter, statusFilter, sortFilter, pagination } = props;

    const filters: any = {
      dateRange: datesFilter,
      status: statusFilter,
      sort: sortFilter
    };
    if (newpage - 1 !== pagenumber) {
      setPagenumber(newpage - 1);
      const newPagination = {
        page: newpage - 1
      };
      getInvoices(filters, newPagination);
    }
  };
  const handleClickListItem = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuItemClick = (event: any, index: number) => {
    const { filtervalues, pagination } = props;
    setSelectedIndex(index);
    setAnchorEl(null);
    if (
      rowscount &&
      rowscount.length > 0 &&
      invoiceData &&
      invoiceData.length > 0
    ) {
      const selectedInvoices: any = [];
      rowscount.forEach(ele => {
        const newObj = { transactionId: '', invoiceNumber: '' };
        const indexVal = invoiceData.findIndex((val: any, i: any) => i === ele);
        newObj.transactionId = invoiceData[indexVal].transactionId;
        newObj.invoiceNumber = invoiceData[indexVal].invoiceNumber;
        selectedInvoices.push(newObj);
      });
      if (selectedInvoices && selectedInvoices.length > 0) {
        InvoiceService.exportSelectedInvoices(
          exportOptions[index].value,
          selectedInvoices
        ).then((response: any) => {
          downloadFile(
            response.data,
            `SelectedInvoices_${LocaleFormating.getNowDate('short')}.${
              exportOptions[index].value
            }`
          );
        });
      }
    } else {
      if (exportOptions[index].value === 'pdf') {
        InvoiceService.exportOriginalInvoices(
          exportOptions[index].value,
          filtervalues,
          pagination
        ).then((response: any) => {
          downloadFile(
            response.data,
            `All_Invoices_${LocaleFormating.getNowDate('short')}.pdf`
          );
        });
      } else if (exportOptions[index].value === 'xlsx') {
        InvoiceService.exportOriginalInvoices(
          exportOptions[index].value,
          filtervalues,
          pagination
        ).then((response: any) => {
          downloadFile(
            response.data,
            `All_Invoices_${LocaleFormating.getNowDate('short')}.xlsx`
          );
        });
      } else if (exportOptions[index].value === 'csv') {
        InvoiceService.exportOriginalInvoices(
          exportOptions[index].value,
          filtervalues,
          pagination
        ).then((response: any) => {
          downloadFile(
            response.data,
            `All_Invoices_${LocaleFormating.getNowDate('short')}.csv`
          );
        });
      }
    }
  };

  const handleNextPage = () => {
    props.changeCurrentPage('next');
  };
  const handlePrevPage = () => {
    props.changeCurrentPage();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handlePageSizeChange = (pageSize: any) => {
    const { datesFilter, statusFilter, sortFilter, pagination } = props;
    const filters: any = {
      dateRange: datesFilter,
      status: statusFilter,
      sort: sortFilter
    };
    const newPagination = {
      page: 0,
      size: pageSize
    };
    getInvoices(filters, newPagination);
  };

  const { getInvoices } = props;

  const { invoiceData } = props;
  const onRowSelectionChange = (
    currentRowsSelected: any,
    allRowsSelected: any,
    rowsSelectedpath: any
  ) => {
    props.isChecked(rowsSelectedpath, invoiceData);

    setRowscount(rowsSelectedpath);
  };

  // React.useEffect(() => {
  //   const datChecked = invoiceData.map((item: any, index: any) => index);
  //   setRowscount(datChecked);
  //   if (datChecked.length > 0) {
  //     props.isChecked(datChecked, invoiceData);
  //   }
  // }, [invoiceData]);
  const options = {
    filter: false,
    search: false,
    download: false,
    disableToolbarSelect: true,
    expandableRows: true,
    rowsSelected: rowscount,
    pagination: false,
    print: false,
    responsive: 'standard' as Responsive,
    selectableRows: false as any,
    sortOrder: sortOrderState as any,
    onRowSelectionChange,
    renderExpandableRow: (rowData: any, rowMeta: any) => {
      console.log(rowData, rowMeta);
      const selectedCreditDataIndex = props.invoiceData.findIndex(
        (el: any) => el.invoiceNumber === rowData[1]
      );
      const selectedCreditData =
        props.invoiceData[selectedCreditDataIndex].mappedCredits;
      const isSelectedCreditDataWarning =
        props.invoiceData[selectedCreditDataIndex].label;
      console.log(selectedCreditData);
      if (selectedCreditData && selectedCreditData.length > 0) {
        return selectedCreditData.map((val: any) => (
          <TableRow
            className={`original-credit${
              isSelectedCreditDataWarning ? '-warning' : ''
            } oldest-subtable ${
              env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 'ca-env-page' : ''
            }`}
          >
            <TableCell colSpan={14}>
              <label>
                <b>{i18n.t('invoices.creditMemoNo')} #</b> <br />{' '}
                {val.invoiceNumber ? val.invoiceNumber : '-'}
              </label>
              <label>
                <b>{i18n.t('invoices.pmtAmt')}</b> <br />
                {!isNaN(val.paymentAmountLine)
                  ? currencyFormatter(val.paymentAmountLine)
                  : currencyFormatter(0)}
              </label>
              <label>
                <b> {i18n.t('invoices.invDate')}</b> <br />
                {val.invoiceDate ? val.invoiceDate : '-'}
              </label>
              <label>
                <b> {i18n.t('invoices.poNo')} #</b> <br />
                {val.poNumber ? val.poNumber : '-'}
              </label>
              <label>
                <b> {i18n.t('invoices.oriInvNo')}</b> <br />
                {val.previousInvoice ? val.previousInvoice : '-'}
              </label>
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                ''
              ) : (
                <label>
                  <b> {i18n.t('invoices.nardaNo')}</b> <br />
                  {val.nardaNumber ? val.nardaNumber : '-'}
                </label>
              )}
              <label>
                <b>{i18n.t('invoices.description')}</b> <br />
                {val.description ? val.description : '-'}
              </label>
              <label>
                <b>{i18n.t('invoices.totalAmt')}</b> <br />
                {!isNaN(val.totalAmount)
                  ? currencyFormatter(val.totalAmount)
                  : currencyFormatter(0)}
              </label>
              <label>
                <b> {i18n.t('invoices.remAmt')}</b> <br />
                {!isNaN(val.remainingAmount)
                  ? currencyFormatter(val.remainingAmount)
                  : currencyFormatter(0)}
              </label>
            </TableCell>
          </TableRow>
        ));
      }
      return null;
    },
    draggableColumns: {
      enabled: true
    },
    customToolbar: () => (
      <>
        {/* <span className="export-icon">
          <Button
            aria-controls="fade-menu"
            aria-haspopup="true"
            onClick={handleClickListItem}
          >
            <img className="image-icon" src={exportIcon} />
            <img className="down-arrow" src={downarrowIcon} />
          </Button>
        </span> */}
        {props.totalPages !== 0 ? (
          <div className="rp-product-status--paginator oldest-pagination">
            <div>
              <span className="left-arrow" onClick={handlePrevPage}>
                &lt;
              </span>
              <span className="current-page">
                {props.currentActivePage + 1}
              </span>
              <span className="right-arrow" onClick={handleNextPage}>
                &gt;
              </span>
              <span className="page-count">of {props.totalPages} Page(s)</span>
            </div>
          </div>
        ) : (
          <span />
        )}
        <Menu
          id="fade-menu"
          anchorEl={anchorEl}
          keepMounted={true}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          {exportOptions.map((exportoptions, index) => (
            <MenuItem
              key={exportoptions.value}
              // selected={index === index}
              onClick={event => handleMenuItemClick(event, index)}
            >
              {exportoptions.label}
            </MenuItem>
          ))}
        </Menu>

        {/* <div className="rp-product-status--paginator">
          <CustomPaginator
            activePage={
              props.pagination.pageNumber ? props.pagination.pageNumber + 1 : 1
            }
            totalPages={props.pagination.totalPages}
            itemsPerPage={props.pagination.pageSize}
            onPageChanged={handlePagination}
            totalItems={props.pagination.totalPages * props.pagination.pageSize}
            showPageInfo={true}
            onPageSizeChange={handlePageSizeChange}
            showPageRangeChange={true}
            currentPageSize={props.pagination.pageSize}
          />
        </div> */}
      </>
    ),
    onViewColumnsChange: (changedColumn: any, action: any) => {
      // console.log("onViewColumnsChange");
      // console.log(changedColumn, action);
      checkDisplayState(changedColumn, action === 'add' ? true : false, true);
    },
    onColumnSortChange: (changedColumn: string, direction: string) => {
      // console.log("onColumnSortChange");
      // console.log(changedColumn, direction);
      const dir = direction;
      setSortOrderState({ name: changedColumn, direction: dir });
    }
  };
  const columns = [
    {
      label: 'Label',
      name: 'label',
      options: {
        display: checkDisplayState('label', true, false),
        filter: false,
        sort: false,
        customBodyRender: (value: any, tablemeta: any) => {
          // return <label>$ {value ? parseFloat(value).toFixed(2) : '0'}</label>;
          return (
            <div>
              {value ? (
                <img src={warningIcon} onClick={showWarningMessage} />
              ) : (
                ''
              )}
            </div>
          );
        }
      }
    },
    {
      label: `${i18n.t('invoices.invoiceNum')}`,
      name: 'invoiceNumber',
      options: {
        display: checkDisplayState('invoiceNumber', true, false),
        sort: false
      }
    },
    {
      label: `${i18n.t('invoices.filters.invoiceDate')}`,
      name: 'invoiceDate',
      options: {
        display: checkDisplayState('invoiceDate', true, false),
        sort: false
      }
    },
    {
      label: `${i18n.t('invoices.orderNo')}`,
      name: 'orderNumber',
      options: {
        display: checkDisplayState('orderNumber', true, false),
        sort: false
      }
    },
    {
      label: `${i18n.t('invoices.poNo')}`,
      name: 'poNumber',
      options: {
        display: checkDisplayState('poNumber', true, false),
        sort: false
      }
    },
    {
      label: `${i18n.t('invoices.description')}`,
      name: 'description',
      options: {
        display: checkDisplayState('description', true, false),
        sort: false
      }
    },
    {
      label: `${i18n.t('invoices.oriInvNo')}`,
      name: 'previousInvoice',
      options: {
        display: checkDisplayState('previousInvoice', true, false),
        sort: false
      }
    },
    {
      label: `${i18n.t('invoices.nardaNo')}`,
      name: 'nardaNumber',
      options: {
        display:
          env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? false
            : checkDisplayState('nardaNumber', true, false),
        sort: false
      }
    },
    {
      label: `${i18n.t('invoices.totalAmt')}`,
      name: 'totalAmount',
      options: {
        display: checkDisplayState('totalAmount', true, false),
        filter: false,
        sort: false,
        customBodyRender: (value: any, tablemeta: any) => {
          // return <label>$ {value ? parseFloat(value).toFixed(2) : '0'}</label>;
          return (
            <label>
              {value ? currencyFormatter(value) : currencyFormatter(0)}
            </label>
          );
        }
      }
    },
    {
      label: `${i18n.t('invoices.remAmt')}`,
      name: 'remainingAmount',
      options: {
        display: checkDisplayState('remainingAmount', true, false),
        filter: false,
        sort: false,
        customBodyRender: (value: any, tablemeta: any) => {
          // return <label>$ {parseFloat(value).toFixed(2)}</label>;
          return (
            <label>
              {value ? currencyFormatter(value) : currencyFormatter(0)}
            </label>
          );
        }
      }
    },
    {
      label: `${i18n.t('invoices.filters.dueDate')}`,
      name: 'dueDate',
      options: {
        display: checkDisplayState('dueDate', true, false),
        sort: false
      }
    },
    {
      label: `${i18n.t('invoices.pmtAmt')}`,
      name: 'pmtAmt',
      options: {
        display: checkDisplayState('pmtAmt', true, false),
        filter: false,
        sort: false,
        customBodyRender: (value: any, tablemeta: any) => {
          // return <label>$ {value ? parseFloat(value).toFixed(2) : '0'}</label>;
          return (
            <label>
              {value ? currencyFormatter(value) : currencyFormatter(0)}
            </label>
          );
        }
      }
    }
  ];

  return (
    <React.Fragment>
      {props.isPending || props.originalIsPending ? (
        <div className="loader-container">
          <div className="loader" />
        </div>
      ) : (
        <MuiThemeProvider theme={theme}>
          {!props.hideAll && (
            <MUIDataTable
              title={''}
              data={invoiceData}
              columns={columns}
              options={options}
            />
          )}
        </MuiThemeProvider>
      )}
      {showWarning ? (
        <div>
          <Modal handleCloseModal={() => console.log('Modal closed')}>
            <div className="apply-original-modal">
              <div className="d-flex justify-space-bw">
                <div className="modal-label">
                  <b>{i18n.t('invoices.unabletoprocesstheinvoice')}</b>
                </div>
                <div className="close-icon" onClick={clickclose}>
                  <img src={CloseIcon} />
                </div>
              </div>
              <div className="modal-content">
                {i18n.t(
                  'invoices.inpendingstateWewillnotbeabletoprocessthisfurther'
                )}
              </div>

              <div className="text-align-center">
                <button className="ok-btn" onClick={clickclose}>
                  {i18n.t('invoices.oK')}
                </button>
              </div>
            </div>
          </Modal>
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  );
}

export default OriginalInvoice;
